import ServiceBase from './ServiceBase';

export default class CodingWorksheetService extends ServiceBase {
    async getWorksheets() {
        var result = await this.requestJson({
            url: `/api/codingeventworksheet/`,
            method: "GET"
        });

        return result;
    }

    async getWorksheet(id) {
        var result = await this.requestJson({
            url: `/api/codingeventworksheet/${id}`,
            method: "GET"
        });

        return result;
    }

    async searchIcd10Codes(searchText) {
        var result = await this.requestJson({
            url: `/api/codingeventworksheet/icd10codes/search`,
            method: "POST",
            data: { searchText: searchText }
        });
        return result;
    }

    async viewWorksheet(id) {
        var result = await this.requestJson({
            url: `/api/codingeventworksheet/view/${id}`,
            method: "GET"
        });
        return result;
    }

    async createWorksheet(createWorksheetParams) {
        var result = await this.requestJson({
            url: `/api/codingeventworksheet/`,
            method: "POST",
            data: createWorksheetParams
        });
        return result;
    }

    async saveWorksheet(id, codingEvent) {
        var result = await this.requestJson({
            url: `/api/codingeventworksheet/${id}`,
            method: "PUT",
            data: codingEvent
        });
        return result;
    }

}